'use client';

import { Button, TextPassage } from '@petsmart-ui/sparky';
import type { CustomContentProps } from 'notistack';
import { closeSnackbar, SnackbarContent } from 'notistack';
import { forwardRef } from 'react';

import './TwoLineSnackbar.scss';

interface TwoLineSnackbarProps extends CustomContentProps {
    secondaryText: string;
    onClick?: () => void;
    actionText?: string;
    width?: string;
    tone?: 'default' | 'success' | 'error' | 'info';
}

const componentClassname = 'two-line-snackbar';

export const TwoLineSnackbar = forwardRef<HTMLDivElement, TwoLineSnackbarProps>(
    ({ id, message, secondaryText, actionText, onClick, width, tone, ...props }, ref) => {
        const toneClassName = tone && tone !== 'default' ? `${componentClassname}--${tone}` : '';
        const handleActionClick = () => {
            onClick?.();
            if (id) {
                closeSnackbar(id);
            }
        };

        return (
            <SnackbarContent {...props} ref={ref}>
                <div className={`${componentClassname} ${toneClassName}`} style={width ? { width: width } : undefined}>
                    <div className={`${componentClassname}__text`}>
                        <TextPassage>{message}</TextPassage>
                        {secondaryText && <TextPassage>{secondaryText}</TextPassage>}
                    </div>
                    {actionText && (
                        <div className={`${componentClassname}__action`}>
                            <Button onClick={handleActionClick} variant="link" text={actionText} />
                        </div>
                    )}
                </div>
            </SnackbarContent>
        );
    }
);

TwoLineSnackbar.displayName = 'TwoLineSnackbar';
